import React from 'react';

import styles from './Success.module.css';

export const Error = () => {
  return (
    <svg
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.am_Error_Icon}
    >
      <path
        className={styles.am_SVG_circle}
        d="m444.34693,114.07007a236.95276,236.95276 0 0 1 44.1553,137.73747c0,129.97005 -106.94772,236.96443 -236.91777,236.96443s-236.91777,-106.94772 -236.91777,-236.91777s106.94772,-236.96443 236.91777,-236.96443a236.99941,236.99941 0 0 1 168.72548,70.59483"
      />
      <line
        className={styles.am_SVG_error1}
        y2="390"
        x2="390"
        y1="110"
        x1="110"
      />
      <line
        className={styles.am_SVG_error2}
        y2="390"
        x2="110"
        y1="110"
        x1="390"
      />
    </svg>
  );
};
